// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_dm-3";
export var flatBottomCorners = "_dm-5";
export var productImage = "_dm-0";
export var quantityContainer = "_dm-2";
export var quantityHeader = "_dm-6";
export var tooltip = "_dm-1";
export var wrapAndEllipsesOverflow = "_dm-4";